// extracted by css-extract-rspack-plugin
export default {"skeleton":"L864XVl8wxYtxwsv","ssc-loading-ltr":"ZXjrJLUTgH0tGSt5","sscLoadingLtr":"ZXjrJLUTgH0tGSt5","ssc-loading-rtl":"hKm2lSpshmw0hgZ7","sscLoadingRtl":"hKm2lSpshmw0hgZ7"};